import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

import OnStarContainer from '../OnStarContainer';

const initCount = 3;

const Logout = ({ onSignOut }) => {
  const [count, setCount] = useState(initCount);
  const { i18n } = useTranslation();

  useEffect(() => {
    let intervalId;
    if (count > 0) {
      intervalId = setInterval(() => {
        setCount((prevCount) => prevCount - 1);
      }, 1000);
    }

    return () => {
      if (intervalId) {
        clearInterval(intervalId);
      }
    };
  }, [count]);

  useEffect(() => {
    if (!count) {
      onSignOut();
    }
  }, [count, onSignOut]);

  return (
    <OnStarContainer title={i18n.t('papi.general.logout.title')}>
      <div
        style={{
          fontWeight: 'bold',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center',
          minHeight: '10em',
        }}
      >
        <div style={{ color: 'red', marginBottom: '1em' }}>{i18n.t('papi.general.token.expired')}</div>
        <div>
          {i18n.t('papi.general.logout.description')} {count}
        </div>
      </div>
    </OnStarContainer>
  );
};

export default Logout;
